import React, { useState } from "react"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Notes from "./notes"
import Reservations from "./reservations"
import Activities from "./activities"
import i18n from "@/i18n"

interface TabProps {
  customer: any
  customerContact?: any
}

const TABS: React.FC<TabProps>[] = [Reservations, Notes, Activities]

const ClientModalTabs = ({ customer, customerContact }: TabProps) => {
  const [selectedTab, setSelectedTab] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue)
  }

  const CurrentTab = TABS[selectedTab]

  return (
    <div data-testid="panel-clients-modal-tabs-container" className="w-full h-full flex flex-col min-h-0">
      <div className="border-b border-gray-200 pt-4 px-6 flex-shrink-0">
        <Tabs value={selectedTab} onChange={handleChange} aria-label="reservation tabs">
          <Tab
            data-testid="panel-clients-modal-tabs-reservations"
            label={i18n.t("app.clients.client_modal.tabs.reservations")}
          />
          <Tab data-testid="panel-clients-modal-tabs-notes" label={i18n.t("app.clients.client_modal.tabs.comments")} />
          <Tab
            data-testid="panel-clients-modal-tabs-activities"
            label={i18n.t("app.clients.client_modal.tabs.activities")}
          />
        </Tabs>
      </div>
      <div data-testid="panel-clients-modal-tabs-content" className="flex-1 overflow-y-auto min-h-0">
        <CurrentTab customer={customer} customerContact={customerContact} />
      </div>
    </div>
  )
}

export default ClientModalTabs
